import { useState, useCallback, useRef, useEffect } from "react";
import { DEFAULT_HEADERS } from "../util/constants";

export const useHttp = () => {
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const activeHttpRequests = useRef([]);

  const sendRequest = useCallback(
    async (url, method = "GET", body = null, headers = {}, options = {}) => {
      setIsLoading(true);
      const httpAbortCtrl = new AbortController();
      activeHttpRequests.current.push(httpAbortCtrl);
      
      try {
        // Merge headers padrão com headers customizados
        // Se options.useDefaultHeaders for false, usa apenas headers customizados
        const finalHeaders = options.useDefaultHeaders === false
          ? headers
          : {
              ...(method !== "GET" ? DEFAULT_HEADERS.JSON : {}),
              ...headers,
            };

        const response = await fetch(url, {
          method,
          body,
          headers: finalHeaders,
          signal: httpAbortCtrl.signal,
        });
        
        let responseData;
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.includes("application/json")) {
          responseData = await response.json();
        } else {
          const text = await response.text();
          try {
            responseData = JSON.parse(text);
          } catch (parseError) {
            throw new Error(`Invalid response format: ${text.substring(0, 100)}`);
          }
        }

        activeHttpRequests.current = activeHttpRequests.current.filter(
          (e) => e !== httpAbortCtrl
        );

        if (!response.ok) {
          const errorObj = {
            message: responseData?.message || responseData?.error || "Request failed",
            status: response.status,
            response: responseData,
          };
          throw errorObj;
        }
        setIsLoading(false);
        return responseData;
      } catch (err) {
        setError(err.message || err);
        setIsLoading(false);
        throw err;
      }
    },
    []
  );

  const clearError = () => {
    setError(null);
  };
  useEffect(() => {
    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      activeHttpRequests.current.forEach((abortCtrl) => abortCtrl.abort());
    };
  }, []);
  return {
    isLoading,
    error,
    sendRequest,
    clearError,
  };
};
